import { useState, useMemo } from 'react';
import { FolderTreeSelector } from '@/components/ui/app/folder-tree-selector';
import { useTranslation } from 'react-i18next';

export const FORM_FOLDER_MOVE_ID = 'form-folder-move';

export default function FormFolderMove({ item, onSubmit }) {
    const { t } = useTranslation();
    const [destination, setDestination] = useState(null);

    // Empêcher de déplacer un élément dans lui-même
    const disabledIds = useMemo(() => (item?.id ? [item.id] : []), [item?.id]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!destination) return;
        onSubmit({
            directoryId: item.id,
            destination_uniq_id: destination.uniq_id,
            destination_type: destination.type,
            destination_folder_uniq_id: destination.folderUniqId,
        });
    };

    return (
        <form id={FORM_FOLDER_MOVE_ID} onSubmit={handleSubmit} className="flex flex-col flex-1 overflow-hidden">
            {/* Infos de l'élément à déplacer */}
            <div className="px-6 py-3 border-b border-border">
                <p className="text-sm text-muted-foreground">{t('folders:elementADeplacer')}</p>
                <p className="text-sm font-medium text-foreground mt-1">{item?.name}</p>
            </div>

            {/* Sélection de la destination */}
            <div className="flex-1 overflow-hidden">
                <FolderTreeSelector
                    value={destination?.uniq_id}
                    onChange={setDestination}
                    excludeProcedures
                    disabledIds={disabledIds}
                    scrollHeight="h-full"
                />
            </div>
        </form>
    );
}
